// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"d72ca540","407":"ff2a76ee","596":"8c15fba3","623":"bdd1d065"}[chunkId] + ".css";
};